import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Chip,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatDateTime, formatJson, getOutcomeStyle } from './streakAuditUtils';

function StreakDebugLogTable({ logs }) {
  const [expandedRows, setExpandedRows] = useState({});

  if (!logs?.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        No debug logs found. Logs are available after migration 130 is deployed.
      </Typography>
    );
  }

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#fafafa' }}>
            <TableCell sx={{ width: 40 }} />
            <TableCell sx={{ fontWeight: 700 }}>When</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Local date</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Outcome</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Reason</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => {
            const isExpanded = Boolean(expandedRows[log.id]);
            const style = getOutcomeStyle(log.outcome);

            return (
              <React.Fragment key={log.id}>
                <TableRow hover sx={{ '& > td': { borderBottom: isExpanded ? 0 : undefined } }}>
                  <TableCell>
                    <IconButton size="small" onClick={() => toggleRow(log.id)}>
                      {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{formatDateTime(log.created_at)}</TableCell>
                  <TableCell>{log.local_date || '—'}</TableCell>
                  <TableCell>
                    <Chip
                      label={log.outcome}
                      size="small"
                      sx={{ bgcolor: style.bg, color: style.color, fontWeight: 600, fontSize: '0.7rem' }}
                    />
                  </TableCell>
                  <TableCell sx={{ maxWidth: 320 }}>
                    <Typography variant="body2" noWrap title={log.reason || ''}>
                      {log.reason || '—'}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5} sx={{ py: 0 }}>
                    <Collapse in={isExpanded}>
                      <Paper variant="outlined" sx={{ m: 1, p: 1, bgcolor: '#fafafa' }}>
                        <Typography variant="caption" color="text.secondary">Context</Typography>
                        <Typography component="pre" variant="caption" sx={{ m: 0, whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
                          {formatJson(log.context)}
                        </Typography>
                      </Paper>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StreakDebugLogTable;
